// Human wording for a rendering journey's place in the render queue.
export const queueLabel = (j) => {
  const mins = Math.max(1, Math.round((j.queue_eta_seconds || 0) / 60));
  const eta = j.queue_eta_seconds ? ` · about ${mins} min` : "";
  if (j.queue_position === 0) return `Being woven now${eta}`;
  if (j.queue_position > 0) {
    const nth = j.queue_position === 1 ? "next" : `${j.queue_position}${j.queue_position === 2 ? "nd" : j.queue_position === 3 ? "rd" : "th"} in line`;
    return `You're ${nth}${eta}`;
  }
  return "Rendering — this can take a few minutes.";
};
